import React, { useEffect, Fragment, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import withDashboard from "../../HOC/withDashboard";
import Pagination from "../../components/NewPagination";
import { getGiftCardTransaction } from "../../services/GiftCardServices";
import { useNavigate, useParams } from "react-router-dom";
import {
    Button,
    Card,
    IconButton,
    Switch,
    CircularProgress,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Swal from "sweetalert2";
import "./index.css";
import Loader from "../../components/Loader";

const GiftCardTransactions = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    // State for paginated data
    // Pagination states for cards
    const [totalCardDataTransactionRecord, setTotalCardDataTransactionRecordd] =
        useState(0);
    const [cardDataTransaction, setCardDataTransaction] = React.useState([]);
    const [cardDataTransactionFilter, setCardDataFilter] = useState({
        search: "",
        page: 0,
        limit: 10,
    });

    useEffect(() => {
        getGiftCardTransactions();
    }, [cardDataTransactionFilter]);

    const onChangeCardTransactionFilter = (name, value) => {
        setCardDataFilter({ ...cardDataTransactionFilter, [name]: value });
    };

    const getGiftCardTransactions = () => {
        setIsLoading(true);
        dispatch(getGiftCardTransaction(cardDataTransactionFilter))
            .then((res) => {
                setTotalCardDataTransactionRecordd(res?.data?.data?.total);
                setCardDataTransaction(res?.data?.data?.data);
                setIsLoading(false);
            })
            .catch(({ message, errorData, statusCode }) => {
                console.error("Error fetching gift card categories:", message);
                setIsLoading(false);
            });
    };

    return (
        <Fragment>
            <div className="gift-cards-container">
                <div className="gift-cards-button-container"></div>

                {/* Gift Card Categories Section */}
                <Card className="gift-cards-category-card">
                    <div className="table-title mb-2">
                        <span>Gift Card Transactions</span>
                    </div>
                    <div className="gift-cards-table-container mb-5">
                        {isLoading ? (
                            <div className="flex justify-center items-center p-4">
                                <CircularProgress />
                            </div>
                        ) : (
                            <table>
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Card Category</th>
                                        <th>Card Name</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {cardDataTransaction &&
                                        cardDataTransaction.length > 0 &&
                                        cardDataTransaction.map((cardTr) => (
                                            <tr key={cardTr._id}>
                                                <td>{cardTr?._id}</td>
                                                <td>
                                                    {
                                                        cardTr?.giftCategoryId
                                                            .name
                                                    }
                                                </td>
                                                <td>
                                                    {cardTr?.giftCardId.name}
                                                </td>
                                                <td>
                                                    {cardTr.status &&
                                                    cardTr.status == "approved"
                                                        ? "Approved"
                                                        : cardTr.status &&
                                                          cardTr.status ==
                                                              "rejected"
                                                        ? "Rejected"
                                                        : "Pending"}
                                                </td>
                                                <td>
                                                    <IconButton
                                                        onClick={() =>
                                                            navigate(
                                                                "/gift-card-transactions/edit/" +
                                                                    cardTr._id
                                                            )
                                                        }>
                                                        <EditIcon />
                                                    </IconButton>
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                    <div className="gift-cards-pagination-container">
                        <Pagination
                            items={totalCardDataTransactionRecord}
                            initialPage={cardDataTransactionFilter?.page}
                            onChangePage={onChangeCardTransactionFilter}
                            per_page={cardDataTransactionFilter?.limit}
                        />
                    </div>
                </Card>
            </div>
            <Loader />
        </Fragment>
    );
};

export default withDashboard(GiftCardTransactions);
